import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { SignUpComponent } from './sign-up.component';
import { ButtonModule } from '../../shared/button/button.module';
import { PrivacyPolicyDialogModule } from '../../shared/privacy-policy-dialog/privacy-policy-dialog.module';
import { TermsOfServiceDialogModule } from '../../shared/terms-of-service-dialog/terms-of-service-dialog.module';
import { SignupTargets } from '../../../enums/signup-targets.enum';
import { SignUpContainerModule } from './sign-up-container/sign-up-container.module';
import { TrackingResolver } from '../../shared/tracking.resolver';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Routing
        RouterModule.forChild([
            {
                path: '',
                children: [
                    {
                        path: '',
                        component: SignUpComponent,
                    },
                    /** Targeted Roles for Signup */
                    {
                        path: SignupTargets.HOMEOWNER,
                        loadChildren: () => import('./homeowner-sign-up/homeowner-sign-up.module').then(m => m.HomeownerSignUpModule),
                    },
                    {
                        path: SignupTargets.BOARD_MEMBER,
                        loadChildren: () => import('./board-sign-up/board-sign-up.module').then(m => m.BoardSignUpModule),
                    },
                    {
                        path: SignupTargets.PROPERTY_MANAGER,
                        loadChildren: () => import('./pmc-sign-up/pmc-sign-up.module').then(m => m.PmcSignUpModule),
                    },
                    /** Branded Organization for Signup */
                    {
                        path: ':org_url',
                        loadChildren: () => import('../login/branded-login/branded-login.module').then(m => m.BrandedLoginModule),
                    },
                ],
                resolve: {
                    tracking: TrackingResolver,
                },
            },
        ]),
        ButtonModule,
        SignUpContainerModule,
        PrivacyPolicyDialogModule,
        TermsOfServiceDialogModule,
    ],
    declarations: [SignUpComponent],
    providers: [],
    exports: [],
})
export class SignUpModule
{
}
